<template>
    <div class="text-md-left shop-info-modal">
        <el-form :model="data.shopDetail" :rules="rules" ref="shopInfo" label-width="220px" label-position="left">
            <el-form-item label="ชื่อร้าน" prop="name">
                <el-input v-model="data.shopDetail.name"></el-input>
            </el-form-item>
            <el-form-item label="Shop Code" prop="shopCode" class="labelForm">
                <el-select v-model="data.shopDetail.shopCode" placeholder="shop code"
                :loading="loadingShopCode">
                    <el-option
                    v-for="(item,index) in shopCodeList"
                    :key="index"
                    :label="'('+item.shopId+') ' + item.shopName"
                    :value="item.shopId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="ประเภทร้านค้า">
                <el-select v-model="data.shopDetail.goodsType">
                    <el-option v-for="(item, index) in shopGoodsTypeList"
                        :key="index"
                        :value="item.id"
                        :label="item.label">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="เบอร์โทรร้าน" prop="phoneNumber">
                <el-input v-model="data.shopDetail.phoneNumber"></el-input>
            </el-form-item>
            <el-form-item label="LINE" prop="line">
                <el-input v-model="data.shopDetail.line"></el-input>
            </el-form-item>
            <el-form-item label="FACEBOOK" prop="facebook">
                <el-input v-model="data.shopDetail.facebook"></el-input>
            </el-form-item>
            <el-row>
                <el-col :span="16" style="padding-right: 10px;">
                    <el-form-item label="FACEBOOK PAGE ID" prop="facebookPageId">
                        <el-input v-model="data.shopDetail.facebookPageId"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8" style="padding-top: 7px;">
                   Auto Sent Message <el-switch v-model="data.shopDetail.autoSendMessage"></el-switch>
                </el-col>
            </el-row>
            <el-form-item label="INSTAGRAM" prop="instagram">
                <el-input v-model="data.shopDetail.instagram"></el-input>
            </el-form-item>
            <el-form-item label="ที่อยู่บนใบปะหน้า" prop="address">
                <el-input v-model="data.shopDetail.address"></el-input>
            </el-form-item>
            <address-system
                            ref="formCustomerAddress"
                            :address="customerAddress"
                            :isSubmitForm="isSubmitForm"
                            :isCancel="isCancel"
                            @updated:address="updateCustomerAddress($event)"
                            @onCancel="(value)=>$emit('onCancel', value)" />

            <!-- <ZipcodeSystem
                ref="zipcode-system-customer"
                class="zipcode-system-shop"
                layout="square"
                :province="customerAddress.province"
                :envelopment="$store.get('envSystem/mode')"
                :district="customerAddress.district"
                :sub-district="customerAddress.subDistrict"
                :zipcode="customerAddress.zipcode"
                @onCompleteAddress="updateCustomerAddress($event)"/> -->
            <!-- <helper-province :info.sync="data.shopDetail"
                                :provincearray="provinceArray"
                                :name="nameProvince"
                                :geo="geoHierarchyData" /> -->
                                <hr style="margin-bottom:20px;">
            <el-form-item label="ที่อยู่เข้ารับสินค้า" prop="pickedUpAddress">
                <el-input v-model="data.shopDetail.pickedUpAddress"></el-input>
            </el-form-item>
            <address-system
                            ref="formPickupAddress"
                            :address="pickupAddress"
                            :isSubmitForm="isSubmitForm"
                            :isCancel="isCancel"
                            @updated:address="updatePickupAddress($event)"
                            @onCancel="(value)=>$emit('onCancel', value)" />
            <!-- <ZipcodeSystem ref="zipcode-system-pickup"
                    class="zipcode-system-shop"
                    layout="square"
                    :province="pickupAddress.province"
                    :envelopment="$store.get('envSystem/mode')"
                    :district="pickupAddress.district"
                    :sub-district="pickupAddress.subDistrict"
                    :zipcode="pickupAddress.zipcode"
                    @onCompleteAddress="updatePickupAddress($event)"/> -->
            <!-- <helper-province-pick-up :info.sync="data.shopDetail"
                                :provincearray="provinceArray"
                                :name="nameProvincePickup"
                                :geo="geoHierarchyData" /> -->
            <el-form-item label="บังคับอัพโหลดสลิป">
                <el-switch v-model="data.shopDetail.activeUploadSlip"></el-switch>
            </el-form-item>
            <el-form-item label="รูปร้านค้า">
                <el-image :src="pictureShop" style="height: 250px;width: 250px;">
                <div slot="placeholder" class="image-slot">
                    Loading<span class="dot">...</span>
                </div>
                </el-image>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
// import ZipcodeSystem from '@bit/fillgoodscompany.fg-component.zipcode-system'
import AddressSystem from '@/components/address/AddressSystem.vue'
// import helperProvince from '@/components/helper/BaseProvinceSelect'
// import helperProvincePickUp from '@/components/helper/BaseProvinceSelectPickUp'
export default {
    name: 'shopInfoForm',
    components: {
        // ZipcodeSystem,
        'address-system': AddressSystem
        // helperProvince,
        // helperProvincePickUp
    },
    props: {
        data: {
            type: Object,
            default: null
        },
        provinceArray: {
            type: Array,
            default: null
        },
        geoHierarchyData: {
            type: Object,
            default: null
        },
        isSubmitForm: {
            type: Boolean,
            default: false
        },
        isCancel: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            loadingShopCode: false,
            shopCodeList: [],
            rules: {
                name: [{ required: true, message: 'กรุณากรอกชื่อร้าน', trigger: 'blur' }],
                shopCode: [{ required: true, message: 'กรุณาเลือก shop code', trigger: 'blur' }],
                phoneNumber: [{ required: true, message: 'กรุณากรอกเบอร์โทรร้าน', trigger: 'blur' }],
                address: [{ required: true, message: 'กรุณากรอกที่อยู่ร้าน', trigger: 'blur' }],
                // province: [{ required: true, message: 'กรุณาเลือกจังหวัด', trigger: 'change' }],
                // district: [{ required: true, message: 'กรุณาเลือกอำเภอ', trigger: 'change' }],
                // subDistrict: [{ required: true, message: 'กรุณาเลือกตำบล', trigger: 'change' }],
                pickedUpAddress: [{ required: true, message: 'กรุณากรอกที่อยู่ร้าน', trigger: 'blur' }]
                // pickedUpSubDistrict: [{ required: true, message: 'กรุณาเลือกจังหวัด', trigger: 'change' }],
                // pickedUpProvince: [{ required: true, message: 'กรุณาเลือกอำเภอ', trigger: 'change' }],
                // pickedUpDistrict: [{ required: true, message: 'กรุณาเลือกตำบล', trigger: 'change' }]
            },
            pictureShop: '',
            // nameProvince: {
            //     provi: 'province',
            //     subDist: 'subDistrict'
            // },
            // nameProvincePickup: {
            //     provi: 'pickedUpProvince',
            //     distr: 'pickedUpDistrict',
            //     subDist: 'pickedUpSubDistrict'
            // },
            customerAddress: {
                province: '',
                district: '',
                subDistrict: '',
                zipcode: '' },
            pickupAddress: {
                province: '',
                district: '',
                subDistrict: '',
                zipcode: '' }
        }
    },
    watch: {
        'data.dialogVisible': {
            immediate: true,
            handler (val) {
                this.shopCodeList = []
                if (val) {
                    this.customerAddress.province = this.data.shopDetail.province
                    this.customerAddress.district = this.data.shopDetail.district
                    this.customerAddress.subDistrict = this.data.shopDetail.subDistrict
                    this.customerAddress.zipcode = this.data.shopDetail.zipcode
                    this.pickupAddress.province = this.data.shopDetail.pickedUpProvince
                    this.pickupAddress.district = this.data.shopDetail.pickedUpDistrict
                    this.pickupAddress.subDistrict = this.data.shopDetail.pickedUpSubDistrict
                    this.pickupAddress.zipcode = this.data.shopDetail.pickedUpZipcode
                    this.remoteMethodShopCode()
                    this.getShopPicture()
                } else {
                    // if (this.$refs['zipcode-system-customer']) { this.$refs['zipcode-system-customer'].$v.$reset() } **
                    // if (this.$refs['zipcode-system-pickup']) { this.$refs['zipcode-system-pickup'].$v.$reset() } **

                    this.customerAddress.province = ''
                    this.customerAddress.district = ''
                    this.customerAddress.subDistrict = ''
                    this.customerAddress.zipcode = ''
                    this.pickupAddress.province = ''
                    this.pickupAddress.district = ''
                    this.pickupAddress.subDistrict = ''
                    this.pickupAddress.zipcode = ''
                    this.pictureShop = ''
                }
            }
        }
    },
    created () {
        this.shopCodeList = []
        if (this.data.dialogVisible) {
            this.remoteMethodShopCode()
            this.getShopPicture()
        } else {
            this.pictureShop = ''
        }
    },
    methods: {
        async remoteMethodShopCode () {
            this.loadingShopCode = true
            try {
                let param = {
                    target_user_id: this.data.shopDetail.userId
                }
                let res = await fgApi.shop.getUserCode(param)
                if (res.success) {
                    this.shopCodeList = res.data.map(e => { return { shopId: String(e.id), shopName: e.name } })
                }
            } catch (error) {
                console.error(error)
            }
            this.loadingShopCode = false
        },
        async getShopPicture () {
            const getFirebaseShopPicturePath = (shopId) => {
                return 'shops/' + shopId + '/logo.jpg'
            }
            const env = (mode) => {
                if (mode === 'production') {
                    return 'prod'
                } else {
                    return mode
                }
            }
            try {
                let storageRef = this.$store.get('fgFirbaseApp/' + env(this.$store.get('envSystem/mode'))).storage().ref()
                let directoryRef = await storageRef.child(getFirebaseShopPicturePath(this.data.shopDetail.shopId))
                let userProfileUrl = await directoryRef.getDownloadURL()
                this.pictureShop = userProfileUrl
            } catch (error) {
                this.pictureShop = require('@/assets/shop-image.png')
            }
        },
        updateCustomerAddress (address) {
            this.data.shopDetail.province = address.province
            this.data.shopDetail.district = address.district
            this.data.shopDetail.subDistrict = address.subDistrict
            this.data.shopDetail.zipcode = address.zipcode
        },
        // updateCustomerAddress (address) {
        //     this.data.shopDetail.province = address.name.province
        //     this.data.shopDetail.district = address.name.district
        //     this.data.shopDetail.subDistrict = address.name.subDistrict
        //     this.data.shopDetail.zipcode = address.name.zipcode
        //     // console.log(this.data.shopDetail)
        // },
        updatePickupAddress (address) {
            this.data.shopDetail.pickedUpProvince = address.province
            this.data.shopDetail.pickedUpDistrict = address.district
            this.data.shopDetail.pickedUpSubDistrict = address.subDistrict
            this.data.shopDetail.pickedUpZipcode = address.zipcode
            // console.log(this.data.shopDetail)
        }
        // updatePickupAddress (address) {
        //     this.data.shopDetail.pickedUpProvince = address.name.province
        //     this.data.shopDetail.pickedUpDistrict = address.name.district
        //     this.data.shopDetail.pickedUpSubDistrict = address.name.subDistrict
        //     this.data.shopDetail.pickedUpZipcode = address.name.zipcode
        //     // console.log(this.data.shopDetail)
        // }
    }
}
</script>
<style lang="scss">
.shop-info-modal{
    .zipcode-system-shop{
      padding-bottom: 12px;
    .-square:nth-child(1){
        padding: 12px 0px !important;
    }
    .-square:nth-child(3){
        padding: 12px 0px !important;
    }
      .input{
          width: 100% !important;
        }
        //   ._bordererror{
        //       border: 1px solid #F56C6C !important;
        //   }
          .field{
            color: #606266;
            display: flex;
            align-items: center;
            .label{
                min-width: 99px!important;
            }
            .input{
                .field{
                    // padding-left: 15px;
                    border: 1px solid #DCDFE6;
                }
            }
          }
        //   .field:focus{
        //     border: 1px solid #26a69a !important;
        //     outline:none;
        //   }
        //   .field:disabled{
        //     background-color: #F5F7FA !important;
        //   }
        //   .errormessage{
        //       color: #F56C6C !important;
        //   }
          .icon{
            font-size: 24px;
            display: flex;
            justify-content: center;
            align-items: center;
          }
  }
}
</style>
